import { useSelector } from "react-redux";
import { selectedBMSRState, selectedRidersState } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { PROPOSAL_RIDERS } from "../../constant/gms-constant";
import { selectAmountOfLoansRiders } from "../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice";

export const useRidersForLoanAmount = () => {
    const selectedRiders = useSelector(selectedRidersState) ?? [];
    const selectedBMSR = useSelector(selectedBMSRState);
    const amountOfLoansRiders = useSelector(selectAmountOfLoansRiders);
    const amountBMSR = selectedBMSR?.inputs?.[0]?.fAmount ?? 0;

    const isSelected = (id: number) => selectedRiders.some(r => r.id === id);

    // NON-FLEXIBLE RIDERS
    const staticRiders = [
        (isSelected(PROPOSAL_RIDERS.BMSR.productFor.GCI) || isSelected(PROPOSAL_RIDERS.BMSR.productFor.GYRT)) && {
            rider_id: isSelected(PROPOSAL_RIDERS.BMSR.productFor.GCI)
                ? Number(PROPOSAL_RIDERS.BMSR.productFor.GCI)
                : Number(PROPOSAL_RIDERS.BMSR.productFor.GYRT),
            amount: amountBMSR,
        },
    ].filter(
        (rider): rider is { rider_id: number; amount: number } => Boolean(rider),
    );

    const staticRiderIds = staticRiders.map(rider => rider.rider_id);

    // FLEXIBLE RIDERS
    const dynamicRiders = selectedRiders
        .filter(rider => !staticRiderIds.includes(rider.id))
        .map(rider => {
            const amountOfLoans = amountOfLoansRiders?.find(r => r.id === rider.id);
            const value = Number(amountOfLoans?.rider?.fAmount) || 0;

            return {
                rider_id: rider.id,
                amount: value,
            };
        });

    return [...dynamicRiders, ...staticRiders];
};